import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/CCSFooter.js";
import MainFeature1 from "components/features/WishLists.js";

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <MainFeature1
      />
      <Footer />
    </AnimationRevealPage>
  );
};
